import axiosInstance from './axios-interceptors';
import authHeader from './auth-header';
const API_URL = '/api/auth/';

class AuthService {
  login(user) {
    return axiosInstance
        .post(API_URL + 'signin', {
          username: user.username,
          password: user.password
        })
        .then(response => {
          if (response.data.accessToken) {
            localStorage.removeItem('adminUserBeforeImpersonation');
            localStorage.setItem('user', JSON.stringify(response.data));
          }

          return response.data;
        });
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('adminUserBeforeImpersonation');
  }

  register(user) {
    return axiosInstance.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      companyName: user.companyName,
      contactPhone: user.contactPhone,
      idTrgovca: user.idTrgovca,
      password: user.password,
      passwordConfirm: user.passwordConfirm
    });
  }

  forgotPassword(user) {
    return axiosInstance.post(API_URL + 'forgot-password', {
      email: user.email
    });
  }

  resetPassword(token, password, passwordConfirm) {
    return axiosInstance.post(API_URL + 'reset-password/' + token, {
      password: password,
      passwordConfirm: passwordConfirm
    });
  }

  getApiKey() {
    return axiosInstance.get(API_URL + 'user/api-key', { headers: authHeader() });
  }

  generateApiKey() {
    return axiosInstance.post(API_URL + 'user/generate-api-key', {}, { headers: authHeader() });
  }
}

export default new AuthService();
